<template>
  <div>
    <CRow class="content-fade-in">
      <CCol md="12">
        <CCard>
          <CCardBody>
            <CForm class="form-basic">
              <CRow>
                <CCol sm="12" md="12" xl="12">
                  <BaseInput
                    :options="nameInput.options"
                    :data="nameInput.data"
                    :listener="nameInput.listener"
                  />
                </CCol>
                <CCol sm="12" md="12" xl="12">
                  <BaseSelect
                    :options="typeSelect.options"
                    :data="typeSelect.data"
                    ref="typeSelect">
                  </BaseSelect>
                </CCol>
                <CCol sm="12" md="12" xl="12">
                  <div class="form-group">
                    <label>Chọn tệp tin</label>
                    <br/>
                    <CButton :disabled="typeSelect.data.model == ''"
                             color="primary"
                             class="btn-action-primary mr-2"
                             @click="chooseFile()"
                    >
                      <i class="fa fa-file"></i> Chọn tệp tin
                    </CButton>
                  </div>
                </CCol>
                <CCol sm="6" md="12" xl="12" class="mt-4">
                  <div class="form-group">
                    <label
                    >Danh sách tệp tin <span class="required">*</span></label
                    >
                    <div
                      class="valid-error"
                      v-show="
                        !(selectedFiles.data.validator
                          ? selectedFiles.data.validator.isValid
                          : true)
                      "
                    >
                      {{
                        selectedFiles.data.validator
                          ? selectedFiles.data.validator.errorMessage
                          : ""
                      }}
                    </div>
                    <br/>
                    <CDataTable
                      :items="selectedFiles.data.model"
                      :fields="chooseFileTable.options.fields"
                      :sorterValue="{ column: null, asc: 'true' }"
                    >
                      <template #name="{ item }">
                        <td>{{ item.name }}</td>
                      </template>
                      <template #action="{ index }">
                        <td class="action-btn-group">
                          <div class="action-btn-wrapper">
                            <CButton
                              color="info"
                              variant="outline"
                              v-c-tooltip.hover="'Lên vị trí'"
                              square
                              size="sm"
                              :disabled="index === 0"
                              @click="changeIndexFile(index, 'up')"
                            >
                              <CIcon name="cil-arrow-top"/>
                            </CButton>
                            <CButton
                              color="info"
                              variant="outline"
                              class="ml-1"
                              square
                              size="sm"
                              :disabled="
                                index === selectedFiles.data.model.length - 1
                              "
                              @click="changeIndexFile(index, 'down')"
                              v-c-tooltip.hover="'Xuống vị trí'"
                            >
                              <CIcon name="cil-arrow-bottom"/>
                            </CButton>
                            <CButton
                              color="danger"
                              variant="outline"
                              class="ml-1"
                              square
                              size="sm"
                              @click="deleteFile(index)"
                              v-c-tooltip.hover="'Xóa'"
                            >
                              <CIcon name="cil-trash"/>
                            </CButton>
                          </div>
                        </td>
                      </template>
                      <template slot="no-items-view">
                        <span style="color: #969696">Danh sách trống!</span>
                      </template>
                      <template slot="loading">
                        <BaseLoading :loading="loading"/>
                      </template>
                    </CDataTable>
                  </div>
                </CCol>
              </CRow>
              <br/>
              <CRow>
                <CCol sm="6" md="6">
                  <CButton
                    color="primary"
                    class="btn-action-primary mr-2"
                    @click="submitData"
                  >
                    <i class="fa fa-plus"></i> Thêm mới
                  </CButton>
                  <CButton
                    color="secondary"
                    class="btn-action-primary mr-2"
                    @click="resetData()"
                  ><i class="fa fa-eraser"></i> Làm mới
                  </CButton>
                  <CButton
                    color="secondary"
                    class="btn-action-primary mr-2"
                    @click="$router.go(-1)"
                  ><i class="fa fa-reply"></i> Hủy bỏ
                  </CButton>
                </CCol>
              </CRow>
              <BaseLoading :loading="loading.value"></BaseLoading>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CModal
      title="Chọn tệp tin"
      :show.sync="isShowPopup"
      size="lg"
      :closeOnBackdrop="false"
    >
      <CRow class="content-fade-in">
        <CCol md="12">
          <CForm class="form-basic">
            <CRow>
              <CCol sm="12" md="12" xl="12">
                <BaseSelect
                  :options="chooseFileData.sourceTypeSelect.options"
                  :data="chooseFileData.sourceTypeSelect.data"
                  ref="chooseFileDatasourceTypeSelect"
                ></BaseSelect>
              </CCol>
              <CCol sm="12" md="12" xl="12" class="mb-2">
                <div class="form-group">
                  <label>Tệp tin <span class="required">*</span></label>
                  <multiselect
                    class="mt-2"
                    v-model="chooseFileData.fileInput.data.model"
                    placeholder="Tệp tin"
                    label="text"
                    track-by="value"
                    :options="chooseFileData.fileInput.data.items"
                    selectLabel="Chọn"
                    deselectLabel="Bỏ chọn"
                    selectedLabel="Đã chọn"
                    :close-on-select="false"
                    :multiple="true"
                    :class="
                      !(chooseFileData.fileInput.data.validator
                        ? chooseFileData.fileInput.data.validator.isValid
                        : true)
                        ? 'input-error'
                        : ''
                    "
                  >
                    <span slot="noResult">Không có dữ liệu tương ứng!</span>
                    <span slot="noOptions">Danh sách rỗng!</span>
                  </multiselect>
                  <div
                    class="valid-error"
                    v-show="
                      !(chooseFileData.fileInput.data.validator
                        ? chooseFileData.fileInput.data.validator.isValid
                        : true)
                    "
                  >
                    {{
                      chooseFileData.fileInput.data.validator
                        ? chooseFileData.fileInput.data.validator.errorMessage
                        : ""
                    }}
                  </div>
                </div>
              </CCol>
            </CRow>
          </CForm>
        </CCol>
      </CRow>
      <template v-slot:footer>
        <div slot="footer">
          <button
            type="button"
            class="btn btn-secondary"
            @click="isShowPopup = false"
            :disabled="loadingPopup.value"
          >
            <i class="fa fa-close"></i> Hủy bỏ
          </button
          >&nbsp;
          <button
            type="button"
            class="btn btn-primary"
            @click="submitPopup()"
            :disabled="loadingPopup.value"
          >
            <i class="fa fa-save"></i> Chọn
          </button>
        </div>
      </template>
      <BaseLoading :loading="loadingPopup.value"></BaseLoading>
    </CModal>
  </div>
</template>

<script>
import BaseSelect from "../../base/BaseSelect2";
import BaseInput from "../../base/BaseInput";
import BaseLoading from "../../base/BaseFormLoading";
import Multiselect from "vue-multiselect";
import {LOCATION_CODE_NAME} from "../../../constant";

export default {
  name: "PlayListAdd",
  components: {BaseSelect, BaseInput, BaseLoading, Multiselect},
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Errors",
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data: function () {
    let that = this;
    return {
      loading: {value: false},
      loadingPopup: {value: false},
      isShowPopup: false,
      chooseFileData: {
        sourceTypeSelect: {
          options: {
            filter: false,
            label: "Nguồn tệp tin <span class='required'>*</span>",
          },
          data: {
            name: "sourceType",
            items: [
              {key: "-1", value: "Tất cả nguồn tệp tin"},
              {key: "0", value: "Tệp tin TW"},
              {key: "1", value: "Tệp tin biên tập"},
            ],
            model: "-1",
          },
        },
        fileInput: {
          data: {
            name: "fileIds",
            model: [],
            items: [],
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.chooseFileData.fileInput.data.model;
                if (!value || value.length === 0) {
                  this.isValid = false;
                  this.errorMessage = "Tệp tin không được để trống";
                } else {
                  this.isValid = true;
                }
                return this.isValid;
              },
            },
          },
        },
      },
      nameInput: {
        options: {
          label: "Tên danh sách <span class='required'>*</span>",
          placeholder: "Tên danh sách",
          type: "text",
          maxlength: 256
        },
        data: {
          name: "name",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.nameInput.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Tên danh sách không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            },
          },
        },
      },
      typeSelect: {
        options: {
          filter: false,
          label: "Loại danh sách <span class='required'>*</span>",
          selectAllText: "Chọn loại danh sách"
        },
        data: {
          name: "type",
          items: [
            {key: "-1", value: "Chữ chạy"},
            {key: "0", value: "Văn bản"},
            {key: "1", value: "Hình ảnh"},
            {key: "2", value: "Video"},
          ],
          model: "",
        },
      },
      selectedFiles: {
        data: {
          name: "files",
          model: [],
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.selectedFiles.data.model;
              if (value.length == 0) {
                this.isValid = false;
                this.errorMessage = "Danh sách tệp tin không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            },
          },
        },
      },
      chooseFileTable: {
        options: {
          fields: [
            {key: "name", label: "Tên tệp tin", _style: "width: 40%;"},
            {key: "action", label: "Thao tác", _style: "width: 10%;"},
          ],
          slots: ["index", "name", "action"],
        },
      },
    };
  },
  methods: {
    changeIndexFile(index, type) {
      this.loading.value = true;
      if (type == "up") {
        this.arrayMove(index, index - 1);
      } else if (type == "down") {
        this.arrayMove(index, index + 1);
      }
    },
    async deleteFile(index) {
      let that = this;
      that.loading.value = true;
      that.selectedFiles.data.model.splice(index, 1);
      that.loading.value = false;
    },
    async arrayMove(old_index, new_index) {
      let data = this.selectedFiles.data.model;
      Promise.all(
        (function* () {
          yield new Promise((resolve) => {
            if (new_index >= data.length) {
              let k = new_index - data.length + 1;
              while (k--) {
                data.push(undefined);
              }
            }
            data.splice(new_index, 0, data.splice(old_index, 1)[0]);
            resolve(data);
          });
        })()
      )
        .then(() => {
          this.loading.value = false;
        })
        .catch((error) => {
          // console.log(error);
        });
    },
    resetData() {
      this.nameInput.data.model = "";
      this.typeSelect.data.model = "";
      this.selectedFiles.data.model = [];
    },
    chooseFile: function () {
      this.chooseFileData.fileInput.data.model = [];
      this.loadDataFile();
      this.isShowPopup = true;
    },
    loadDataFile: function () {
      let that = this;
      that.chooseFileData.fileInput.data.model = [];
      this.$helper.loadDataSource({
        url: "/screen-file/listScreenFileBySourceType",
        dataSubmit: function () {
          return {
            sourceType: that.chooseFileData.sourceTypeSelect.data.model,
            type: that.typeSelect.data.model
          };
        },
        ignoreDefaultData: true,
        isJsonContentType: false,
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            that.chooseFileData.fileInput.data.items = response.data.data;
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        },
      });
    },
    submitPopup: function () {
      let that = this;
      let isValid = true;
      isValid &= that.chooseFileData.fileInput.data.validator.valid();
      if (!isValid) {
        return;
      }
      var files = [];
      for (var i = 0; i < that.chooseFileData.fileInput.data.model.length; i++) {
        files.push({
          name: that.chooseFileData.fileInput.data.model[i].text,
          fileId: that.chooseFileData.fileInput.data.model[i].value,
        });
      }
      that.selectedFiles.data.model = that.selectedFiles.data.model.concat(files);
      that.isShowPopup = false;
    },
    submitData: function () {
      let that = this;
      let isValid = true;
      isValid &= that.nameInput.data.validator.valid();
      isValid &= that.selectedFiles.data.validator.valid();

      if (!isValid) {
        return;
      }
      for (var i = 0; i < that.selectedFiles.data.model.length; i++) {
        that.selectedFiles.data.model[i].index = i;
      }

      that.$helper.loadDataSource({
        loading: that.loading,
        url: "/play-list/add",
        dataSubmit: function () {
          return {
            name: that.nameInput.data.model,
            type: that.typeSelect.data.model,
            playListDetailModels: that.selectedFiles.data.model,
          };
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({
              message: that.$helper.getStringError(response.data.data),
            });
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({
              message: "Thêm mới danh sách phát thành công",
            });
            that.$router.push("/screen-editor/play-list.html");
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        },
      });
    },
  },
  computed: {},
  created() {
  },
  mounted() {
  },
  watch: {
    "chooseFileData.sourceTypeSelect.data.model": function () {
      if (this.isShowPopup) {
        this.loadDataFile();
      }
    },
    "typeSelect.data.model": function () {
      this.chooseFileData.sourceTypeSelect.data.model = "-1";
    }
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect.input-error .multiselect__tags {
  border-color: #ff7070;
}

.vc-date {
  display: none !important;
}

.multiselect,
.multiselect .multiselect__tags {
  height: 36px !important;
  min-height: 36px !important;
}

.multiselect__input {
  line-height: unset !important;
  padding-left: 1px !important;
  font-size: 14px !important;
}

.multiselect .multiselect__tags {
  padding-top: 4px !important;
}

.multiselect .multiselect__tag {
  margin-top: 2px !important;
}
</style>
